import { createReducer, on } from '@ngrx/store';
import * as SubscriptionActions from '@store/subscription/subscription.actions';
import { User } from '@core/models';
import { userActions } from '@store/user';
import { BasicTariffs } from '@data/enums';
import { subscriptionActions } from '@store/subscription/subscription.actions';


export const subscriptionFeatureKey = 'subscription';

export type SubscriptionStateType = keyof SubscriptionState;

export interface SubscriptionState {
  followings: {
    value: Array<User>,
    nextPage: number | undefined,
    isLoading: boolean,
    error: unknown
  },
  followers: {
    value: Array<User>,
    nextPage: number | undefined,
    isLoading: boolean,
    error: unknown
  },
  basic: {
    selectedTariff: BasicTariffs
  }
}

export const initialState: SubscriptionState = {
  followings: {
    value: [],
    nextPage: undefined,
    isLoading: false,
    error: undefined,
  },
  followers: {
    value: [],
    nextPage: undefined,
    isLoading: false,
    error: undefined,
  },
  basic: {
    selectedTariff: BasicTariffs.M1,
  },
};

export const subscriptionReducer = createReducer(
  initialState,
  on(subscriptionActions.setBasicTariff,
    (state, { tariff }): SubscriptionState => ({
      ...state,
      basic: {
        selectedTariff: tariff,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowings,
    (state): SubscriptionState => ({
      ...state,
      followings: {
        ...state.followings,
        value: [],
        isLoading: true,
        error: undefined,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowingsSuccess,
    (state, { data: { users, next_page } }): SubscriptionState => ({
      ...state,
      followings: {
        value: [...state.followings.value, ...users],
        nextPage: next_page,
        isLoading: false,
        error: undefined,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowersFailure,
    (state, { error }): SubscriptionState => ({
      ...state,
      followings: {
        value: [],
        nextPage: undefined,
        isLoading: false,
        error: error,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowers,
    (state): SubscriptionState => ({
      ...state,
      followers: {
        ...state.followers,
        isLoading: true,
        error: undefined,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowersSuccess,
    (state, payload): SubscriptionState => ({
      ...state,
      followers: {
        value: [...state.followers.value, ...payload.data.users],
        nextPage: payload.data.next_page,
        isLoading: false,
        error: undefined,
      },
    }),
  ),
  on(SubscriptionActions.loadFollowersFailure,
    (state, payload): SubscriptionState => ({
      ...state,
      followers: {
        value: [],
        nextPage: undefined,
        isLoading: false,
        error: payload.error,
      },
    }),
  ),

  on(
    SubscriptionActions.clearSubscriptionsData,
    (): SubscriptionState => ({ ...initialState }),
  ),
  on(
    SubscriptionActions.reSubscribeSuccess,
    (state, payload): SubscriptionState => {
      if (!payload.from) {
        return { ...state };
      }
      if (payload.from === 'followings') {
        return {
          ...state,
          followings: {
            ...state.followings,
            value: state.followings.value.map(user => {
              return user.user_id === payload.user.user_id
                ? payload.user
                : user;
            }),
          },
        };
      }
      return { ...state };
    },
  ),
  on(
    SubscriptionActions.reSubscribeFailure,
    (state): SubscriptionState => ({ ...state }),
  ),
  on(
    userActions.followUserSuccess,
    (state, payload): SubscriptionState => ({
      ...state,
      followers: {
        ...state.followers,
        value: state.followers.value
          .map(user =>
            user.user_id === payload.user.user_id
              ? { ...user, subscriptions: { is_following: true } }
              : user,
          ),
      },
    }),
  ),
);
